import { PERIODS } from '../views/root/views/dashboard/periods';

const metricsGraph = {
  [PERIODS.LAST_7_DAYS.key]: {
    data: [
      {
        key: 'add-comment@v1',
        action_data: [
          {
            total: 1,
            action: 'add-comment@v1',
            automation_ids: ['1,2,12'],
            start_time: '2023-04-24T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-comment@v1',
            automation_ids: ['3,4,7,11,13'],
            start_time: '2023-04-25T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-comment@v1',
            automation_ids: ['2,5'],
            start_time: '2023-04-26T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-comment@v1',
            automation_ids: ['4'],
            start_time: '2023-04-27T00:00:00.000Z'
          },
          {
            total: 0,
            action: 'add-comment@v1',
            automation_ids: ['4,6'],
            start_time: '2023-04-28T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'add-comment@v1',
            automation_ids: ['7,9,10'],
            start_time: '2023-04-29T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-comment@v1',
            automation_ids: ['3,4,8,11'],
            start_time: '2023-04-30T00:00:00.000Z'
          }
        ]
      },
      {
        key: 'add-reviewers@v1',
        action_data: [
          {
            total: 0,
            action: 'add-reveiwers@v1',
            automation_ids: ['1'],
            start_time: '2023-04-24T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-reveiwers@v1',
            automation_ids: ['7,8,11'],
            start_time: '2023-04-25T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: [],
            start_time: '2023-04-26T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: ['3,6,8'],
            start_time: '2023-04-27T00:00:00.000Z'
          },
          {
            total: 0,
            action: 'add-reveiwers@v1',
            automation_ids: ['2,4,12'],
            start_time: '2023-04-28T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: ['1'],
            start_time: '2023-04-29T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'add-reveiwers@v1',
            automation_ids: ['1,2,5,8,11'],
            start_time: '2023-04-30T00:00:00.000Z'
          }
        ]
      },
      {
        key: 'approve@v1',
        action_data: [
          {
            total: 4,
            action: 'approve@v1',
            automation_ids: ['2,5,8,11'],
            start_time: '2023-04-24T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['1'],
            start_time: '2023-04-25T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'approve@v1',
            automation_ids: ['7,9'],
            start_time: '2023-04-26T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['3,6,9'],
            start_time: '2023-04-27T00:00:00.000Z'
          },
          {
            total: 0,
            action: 'approve@v1',
            automation_ids: ['11'],
            start_time: '2023-04-28T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['10,12,13'],
            start_time: '2023-04-29T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'approve@v1',
            automation_ids: ['2,5'],
            start_time: '2023-04-30T00:00:00.000Z'
          }
        ]
      }
    ]
  },
  [PERIODS.LAST_30_DAYS.key]: {
    data: [
      {
        key: 'add-comment@v1',
        action_data: [
          {
            total: 1,
            action: 'add-comment@v1',
            automation_ids: ['1,2,12'],
            start_time: '2023-04-01T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-comment@v1',
            automation_ids: ['3,4,7,11,13'],
            start_time: '2023-04-08T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-comment@v1',
            automation_ids: ['2,5'],
            start_time: '2023-04-15T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'add-comment@v1',
            automation_ids: ['4'],
            start_time: '2023-04-22T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-comment@v1',
            automation_ids: ['4,6'],
            start_time: '2023-04-29T00:00:00.000Z'
          }
        ]
      },
      {
        key: 'add-reviewers@v1',
        action_data: [
          {
            total: 3,
            action: 'add-reveiwers@v1',
            automation_ids: ['1'],
            start_time: '2023-04-01T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: ['7,8,11'],
            start_time: '2023-04-08T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: [],
            start_time: '2023-04-15T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-reveiwers@v1',
            automation_ids: ['3,6,8'],
            start_time: '2023-04-22T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: ['2,4,12'],
            start_time: '2023-04-28T00:00:00.000Z'
          }
        ]
      },
      {
        key: 'approve@v1',
        action_data: [
          {
            total: 6,
            action: 'approve@v1',
            automation_ids: ['2,5,8,11'],
            start_time: '2023-04-01T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'approve@v1',
            automation_ids: ['1'],
            start_time: '2023-04-08T00:00:00.000Z'
          },
          {
            total: 4,
            action: 'approve@v1',
            automation_ids: ['7,9'],
            start_time: '2023-04-15T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['3,6,9'],
            start_time: '2023-04-22T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'approve@v1',
            automation_ids: ['11'],
            start_time: '2023-04-29T00:00:00.000Z'
          }
        ]
      }
    ]
  },
  [PERIODS.LAST_90_DAYS.key]: {
    data: [
      {
        key: 'add-comment@v1',
        action_data: [
          {
            total: 1,
            action: 'add-comment@v1',
            automation_ids: ['1,2,3,6,12'],
            start_time: '2023-02-01T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-comment@v1',
            automation_ids: ['1,3,4,7,11,13'],
            start_time: '2023-02-08T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-comment@v1',
            automation_ids: ['2,5,9'],
            start_time: '2023-02-15T00:00:00.000Z'
          },
          {
            total: 4,
            action: 'add-comment@v1',
            automation_ids: ['4'],
            start_time: '2023-02-22T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-comment@v1',
            automation_ids: ['4,6,10,12'],
            start_time: '2023-02-28T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-comment@v1',
            automation_ids: ['1,2,3,6,12'],
            start_time: '2023-03-01T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-comment@v1',
            automation_ids: ['1,3,4,7,11,13'],
            start_time: '2023-03-08T00:00:00.000Z'
          },
          {
            total: 4,
            action: 'add-comment@v1',
            automation_ids: ['2,5,9'],
            start_time: '2023-03-15T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-comment@v1',
            automation_ids: ['4'],
            start_time: '2023-03-22T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-comment@v1',
            automation_ids: ['4,6,10,12'],
            start_time: '2023-03-29T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-comment@v1',
            automation_ids: ['1,2,3,6,12'],
            start_time: '2023-04-01T00:00:00.000Z'
          },
          {
            total: 4,
            action: 'add-comment@v1',
            automation_ids: ['1,3,4,7,11,13'],
            start_time: '2023-04-08T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-comment@v1',
            automation_ids: ['2,5,9'],
            start_time: '2023-04-15T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-comment@v1',
            automation_ids: ['4'],
            start_time: '2023-04-22T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-comment@v1',
            automation_ids: ['4,6,10,12'],
            start_time: '2023-04-29T00:00:00.000Z'
          }
        ]
      },
      {
        key: 'add-reviewers@v1',
        action_data: [
          {
            total: 3,
            action: 'add-reveiwers@v1',
            automation_ids: ['3'],
            start_time: '2023-02-01T00:00:00.000Z'
          },
          {
            total: 4,
            action: 'add-reveiwers@v1',
            automation_ids: ['7,8,11'],
            start_time: '2023-02-08T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: [],
            start_time: '2023-02-15T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-reveiwers@v1',
            automation_ids: ['3,6,8'],
            start_time: '2023-02-22T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'add-reveiwers@v1',
            automation_ids: ['2,4,12'],
            start_time: '2023-02-28T00:00:00.000Z'
          },
          {
            total: 4,
            action: 'add-reveiwers@v1',
            automation_ids: ['3'],
            start_time: '2023-03-01T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-reveiwers@v1',
            automation_ids: ['7,8,11'],
            start_time: '2023-03-08T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-reveiwers@v1',
            automation_ids: [],
            start_time: '2023-03-15T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: ['3,6,8'],
            start_time: '2023-03-22T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'add-reveiwers@v1',
            automation_ids: ['2,4,12'],
            start_time: '2023-03-28T00:00:00.000Z'
          },
          {
            total: 4,
            action: 'add-reveiwers@v1',
            automation_ids: ['3'],
            start_time: '2023-04-01T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'add-reveiwers@v1',
            automation_ids: ['7,8,11'],
            start_time: '2023-04-08T00:00:00.000Z'
          },
          {
            total: 2,
            action: 'add-reveiwers@v1',
            automation_ids: [],
            start_time: '2023-04-15T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'add-reveiwers@v1',
            automation_ids: ['3,6,8'],
            start_time: '2023-04-22T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'add-reveiwers@v1',
            automation_ids: ['2,4,12'],
            start_time: '2023-04-28T00:00:00.000Z'
          }
        ]
      },
      {
        key: 'approve@v1',
        action_data: [
          {
            total: 3,
            action: 'approve@v1',
            automation_ids: ['2,5,8,11'],
            start_time: '2023-02-01T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'approve@v1',
            automation_ids: ['1'],
            start_time: '2023-02-08T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['7,9'],
            start_time: '2023-02-15T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'approve@v1',
            automation_ids: ['3,6,9'],
            start_time: '2023-02-22T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'approve@v1',
            automation_ids: ['11'],
            start_time: '2023-02-28T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['2,5,8,11'],
            start_time: '2023-03-01T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'approve@v1',
            automation_ids: ['1'],
            start_time: '2023-03-08T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'approve@v1',
            automation_ids: ['7,9'],
            start_time: '2023-03-15T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['3,6,9'],
            start_time: '2023-03-22T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'approve@v1',
            automation_ids: ['11'],
            start_time: '2023-03-29T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'approve@v1',
            automation_ids: ['2,5,8,11'],
            start_time: '2023-04-01T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['1'],
            start_time: '2023-04-08T00:00:00.000Z'
          },
          {
            total: 3,
            action: 'approve@v1',
            automation_ids: ['7,9'],
            start_time: '2023-04-15T00:00:00.000Z'
          },
          {
            total: 5,
            action: 'approve@v1',
            automation_ids: ['3,6,9'],
            start_time: '2023-04-22T00:00:00.000Z'
          },
          {
            total: 1,
            action: 'approve@v1',
            automation_ids: ['11'],
            start_time: '2023-04-29T00:00:00.000Z'
          }
        ]
      }
    ]
  }
};

export default metricsGraph;
